import { useQuery } from '@apollo/client/react'
import { Center, Separator, Heading, Link, List, Spinner, Text, VStack } from '@chakra-ui/react'
import { NextLink } from '@src/components/sco/utilities/NextLink'
import { gql } from '@src/lib/gql'
import groupBy from 'lodash/groupBy'
import React from 'react'

export type SupportArticlesListProps = {}
export const SupportArticlesList: React.FC<SupportArticlesListProps> = props => {
  const query = useQuery(
    gql`
      query supportArticles($where: SupportArticleWhereInput) {
        supportArticles(where: $where) {
          id
          title
          slug
          category {
            id
            name
            slug
          }
        }
      }
    `,
    {
      variables: {
        where: {
          product: {
            slug: 'startups',
          },
        },
      },
    }
  )

  if (query.loading) {
    return (
      <Center padding={4}>
        <Spinner />
      </Center>
    )
  }

  if (query.error || !query.data) {
    return (
      <Center padding={4}>
        <Text>
          {'Failed to Load: '}
          {query.error?.toString() || 'Error'}
        </Text>
      </Center>
    )
  }

  const groupedArticles = groupBy(query.data.supportArticles, 'category.name')
  const sortedCategories = Object.keys(groupedArticles).sort()

  return (
    <VStack
      align={'stretch'}
      bgColor={'backgroundSecondary'}
      borderRadius={'lg'}
      gap={4}
      padding={[4, 4, 6, 8]}
    >
      {sortedCategories.map(category => (
        <VStack align={'stretch'} gap={4}>
          <Heading>{category}</Heading>
          <Separator marginY={0} />
          <List.Root gap={3}>
            {groupedArticles[category].map(article => (
              <List.Item key={article.id}>
                <Link asChild variant={'underline'}>
                  <NextLink href={`/support/articles/${article.slug}`}>{article.title}</NextLink>
                </Link>
              </List.Item>
            ))}
          </List.Root>
        </VStack>
      ))}
    </VStack>
  )
}
